import { useState, useCallback, useEffect } from "react";
import { FLEX_COL_FILL } from "../../../../../themes/sbux/components";
import { Box } from "@mui/material";
import type { GridRowParams } from "@mui/x-data-grid";
import {
  SbuxGenericGrid,
  SbuxGridToolbar,
} from "../../../../../components/SbuxDataGrid/SbuxGenericGrid";
import useCss from "../../../../../hooks/useCss";
import styles from "./styles";
import { LEX_BOT_COLUMNS } from "./columns";
import { getTranslatedColumns } from "../../../../../components/SbuxDataGrid/utils";
import LexBotDetailModal from "./LexBotDetailModal";
import { useAppDispatch, useAppSelector } from "../../../../../store/types";
import { getLexBots } from "../../../../../services/lexBots";
import {
  getLexBotsDataSelector,
  getLexBotsLoadingSelector,
} from "../../../../../selectors/lexBotsSelector";
import type { LexBotInfo } from "./types";

const LexBotsTable = () => {
  const classes = useCss(styles);
  const dispatch = useAppDispatch();

  const bots = useAppSelector(getLexBotsDataSelector);
  const botsLoading = useAppSelector(getLexBotsLoadingSelector);

  const [selectedBot, setSelectedBot] = useState<LexBotInfo | null>(null);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    dispatch(getLexBots());
  }, [dispatch]);

  const handleOnRowClick = useCallback((params: GridRowParams<LexBotInfo>) => {
    setSelectedBot(params.row);
    setOpenModal(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setOpenModal(false);
    setSelectedBot(null);
  }, []);

  return (
    <Box sx={FLEX_COL_FILL}>
      <SbuxGenericGrid
        rows={bots as Record<string, unknown>[]} // SbuxGenericGrid.rows expects Record<string, unknown>[] - cast is a component interface constraint
        columns={getTranslatedColumns(LEX_BOT_COLUMNS)}
        slots={{ toolbar: SbuxGridToolbar }}
        slotClasses={{
          toolbar: {
            container: classes.toolbarContainer,
          },
          datagrid: {
            container: classes.datagridContainer,
          },
        }}
        isLoading={botsLoading}
        clickableRow
        onRowClick={handleOnRowClick}
      />

      <LexBotDetailModal
        open={openModal}
        bot={selectedBot}
        onClose={handleCloseModal}
      />
    </Box>
  );
};

export default LexBotsTable;
